import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowRight } from 'lucide-react';
import SEOHead from '../components/SEOHead';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-void flex items-center justify-center relative overflow-hidden" data-testid="not-found-page">
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist on Avi Cement's website."
        path="/404"
        noindex
      />
      {/* Background effects */}
      <div className="absolute inset-0 bg-grid opacity-30" />
      <motion.div
        className="absolute w-[600px] h-[600px] rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(243,100,88,0.1) 0%, transparent 60%)' }}
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 4, repeat: Infinity }}
      />

      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* 404 Number */}
          <motion.h1
            className="font-display text-[120px] md:text-[200px] lg:text-[250px] font-bold text-white/5 leading-none"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, type: 'spring' }}
          >
            404
          </motion.h1>

          <div className="-mt-16 md:-mt-24">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Page not found
            </h2>
            
            <p className="text-gray-400 text-lg mb-10 max-w-md mx-auto">
              This page hasn't been built yet. But we've built everything else.
            </p>

            <Link
              to="/"
              data-testid="404-home-link"
              className="inline-flex items-center gap-3 bg-coral hover:bg-coral-dark text-white font-display font-medium px-8 py-4 rounded-full transition-all group"
            >
              <Home className="w-5 h-5" />
              Return to Home
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </motion.div>

        {/* Animated blocks */}
        <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2">
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={i}
              className="w-4 h-4"
              style={{ backgroundColor: i % 2 === 0 ? '#f36458' : '#3b82f6' }}
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 0.3 }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
